








import { defineComponent } from '@vue/composition-api';
import { useVoiceClass } from '@/bundles/VideoContent/composables/useVoiceClass';
import VoiceClassBaseForm from './VoiceClassBaseForm.vue';

export default defineComponent({
  name: 'VoiceClassCreateForm',

  components: {
    VoiceClassBaseForm,
  },

  emits: ['submit'],

  setup(_, {emit}) {
    const {createVoiceClass} = useVoiceClass();
    const saveVoiceClass = async (formData: any) => {
      await createVoiceClass(formData);
      emit('submit');
    };

    return {
      saveVoiceClass,
    };
  },
});
